import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// External dependencies
import { useContext, useEffect, useState, memo, } from 'react';
import { Box, Typography, Grid, IconButton, Dialog, DialogTitle, DialogContent, } from '@mui/material';
import { Clear } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
// Internal dependencies
import { appStyles } from '../App.styles';
import { UserContext } from '../auth';
import { ButtonSG, UploadIconSG } from '../components';
import { IMAGE_FILE_TYPES, TEXT_FILE_TYPES, InfobaseSubtitle, InfobaseTableSG, } from './';
import { UploadFileButtonSG } from '../components';
import { AI_MODELS } from '../chat';
/**
 * Infobase dialog in Chat
 * @param props Props
 * @returns Infobase dialog
 */
export const InfobaseDialog = memo(function ({ aiModel, open, handleInfobaseClose, setAttachFiles, attachFiles, }) {
    // Get user credential
    const user = useContext(UserContext);
    // Get translation function
    const { t, i18n } = useTranslation();
    // Uploading status
    const [uploadLoading, setUploadLoading] = useState(false);
    const [
    /** Supported attach file types by AI model */ attachFileTypes, setAttachFileTypes] = useState([...TEXT_FILE_TYPES, ...IMAGE_FILE_TYPES]);
    useEffect(() => {
        const /** Model metadata */ modelMetadata = AI_MODELS[aiModel];
        const /** Supported Attach Files Types */ supportedAttachFileTypes = (modelMetadata === null || modelMetadata === void 0 ? void 0 : modelMetadata.attachFilesTypes) || [];
        setAttachFileTypes([...supportedAttachFileTypes]);
    }, [aiModel]);
    const [
    /** Reload Infobase files flag */ reloadInfobaseFilesFlag, 
    /** reloadInfobaseFiles setter */ setReloadInfobaseFilesFlag] = useState(0);
    return (_jsxs(Dialog
    // Infobase dialog
    , Object.assign({ 
        // Infobase dialog
        sx: {
            '& .MuiDialog-paper': {
                backgroundColor: '#ffffff',
                borderRadius: '1rem',
                maxWidth: '1024px',
                width: '100%',
                height: {
                    sm: '80%',
                    xs: '90%',
                },
            }
        }, open: open, onClose: handleInfobaseClose }, { children: [_jsx(DialogTitle, Object.assign({ sx: {
                    padding: {
                        sm: '1.5rem 1.5rem 0',
                        xs: '0.5rem 0.5rem 0',
                    }
                } }, { children: _jsxs(Grid, Object.assign({ container: true, spacing: 1, sx: { flexWrap: 'nowrap' } }, { children: [_jsx(Grid, Object.assign({ item: true, sx: {
                                overflow: 'hidden',
                                display: 'flex',
                            } }, { children: _jsx(Typography, Object.assign({ sx: Object.assign(Object.assign({}, appStyles.text28), { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }) }, { children: t('Infobase') })) })), _jsx(Grid, Object.assign({ item: true, xs: true, sx: {
                                '& label': { outline: 'none!important' },
                                '& input': { outline: 'none!important' },
                            } }, { children: _jsx(UploadFileButtonSG, { variant: 'contained', styles: {
                                    display: 'flex', alignItems: 'center',
                                    outline: 'none',
                                    boxShadow: 'none',
                                    border: '1px dashed #707974',
                                    backgroundColor: 'transparent',
                                    color: 'green.main',
                                    boxSizing: 'border-box',
                                    '&:hover': {
                                        border: '1px dashed #707974',
                                        backgroundColor: 'transparent',
                                        boxShadow: 'none',
                                    },
                                    '&:focus': {
                                        outline: 'none',
                                    },
                                }, reloadInfobaseFilesFlag: reloadInfobaseFilesFlag, setReloadInfobaseFilesFlag: setReloadInfobaseFilesFlag, uploadLoading: uploadLoading, setUploadLoading: setUploadLoading, attachFileTypes: attachFileTypes, attachFiles: attachFiles, setAttachFiles: setAttachFiles, startIconSG: _jsx(UploadIconSG, { sx: { color: 'green.main' } }) }) })), _jsx(Grid, Object.assign({ item: true, sx: { display: 'flex', alignItems: 'center', justifyContent: 'flex-end' } }, { children: _jsx(IconButton, Object.assign({ "aria-label": "Close prompt button", onClick: handleInfobaseClose }, { children: _jsx(Clear, { sx: { color: '#1C1B1F' } }) })) }))] })) })), _jsxs(DialogContent, Object.assign({ sx: {
                    padding: {
                        sm: '1.5rem!important',
                        xs: '0.5rem!important',
                    },
                } }, { children: [_jsx(InfobaseSubtitle, { styles: {
                            backgroundColor: 'blueLight.main',
                            margin: '0 0 1rem',
                            display: uploadLoading ? 'block' : 'none'
                        }, text: 'The file is processing. This may take a few minutes. You can attach later when it is ready.' }), _jsx(InfobaseSubtitle, { styles: {
                            backgroundColor: 'greenLight.main',
                            margin: '0 0 1rem',
                            display: {
                                xs: 'none',
                                sm: 'block',
                            }
                        }, text: 'Add files and let AI use them to answer questions and write based on facts.' }), _jsx(Box, Object.assign({ sx: {
                            width: 'auto',
                        } }, { children: _jsx(InfobaseTableSG, { selectedFiles: attachFiles, setSelectedFiles: setAttachFiles, reloadInfobaseFilesFlag: reloadInfobaseFilesFlag, attachFileTypes: attachFileTypes }) })), _jsx(Grid, Object.assign({ container: true, sx: { justifyContent: 'flex-end' } }, { children: _jsx(Grid, Object.assign({ item: true, sx: { padding: '1rem 0 0 0' } }, { children: _jsx(ButtonSG, Object.assign({ variant: 'contained', onClick: handleInfobaseClose }, { children: t('Attach') })) })) }))] }))] })));
});
